import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Heading, Box, Flex, StarRating, Hide, NakedButton } from 'roo-ui/components';
import TripAdvisorRating from 'components/TripAdvisorRating';
import TripAdvisorReviewsModal from 'components/TripAdvisorReviewsModal';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';
import ViewOnMapWithAddress from './ViewOnMapWithAddress';
import MemberFavouritesButton from 'pages/Property/MemberFavouritesButton';

const PropertyHeader = ({ property, tripAdvisorRating, ...rest }) => {
  const { name, latitude, longitude, address, id, rating, ratingType } = property;
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const hasTripAdvisorRating = tripAdvisorRating && tripAdvisorRating.reviewCount > 0;

  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'Tripadvisor Pop Up', value: 'Top Link Selected' });
  }, [emitInteractionEvent, openModal]);

  return (
    <Box {...rest}>
      <Flex flexDirection={['column', 'row']} justifyContent={['inherit', 'space-between']}>
        <Flex flexDirection="column" mb={[4, 3]} mx={[3, 0]}>
          <Heading.h1 data-testid="property-name" fontSize={['lg', 'xl']} lineHeight="tight" mb={4}>
            {name}
          </Heading.h1>
          <Flex alignItems="flex-start">
            <Box mr={3}>
              <StarRating rating={rating} ratingType={ratingType} size={20} />
            </Box>
            {hasTripAdvisorRating && (
              <Fragment>
                <NakedButton onClick={handleOnClick}>
                  <TripAdvisorRating rating={tripAdvisorRating} displayReviews={true} underlined />
                </NakedButton>
                <TripAdvisorReviewsModal {...modalProps} locationId={id} />
              </Fragment>
            )}
          </Flex>
        </Flex>
        <Box borderTop="1" borderColor={['greys.alto', 'transparent']} px={[3, 0]} pt={[4, 0]}>
          <MemberFavouritesButton />
        </Box>
      </Flex>

      <Box mx={[3, 0]}>
        <Hide xs>
          <Flex alignItems="center">
            <ViewOnMapWithAddress locationName={name} latitude={latitude} longitude={longitude} address={address} />
          </Flex>
        </Hide>
      </Box>
    </Box>
  );
};

PropertyHeader.propTypes = {
  property: PropTypes.shape({
    name: PropTypes.string,
    rating: PropTypes.number,
    ratingType: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    id: PropTypes.string,
    address: PropTypes.shape({
      streetAddress: PropTypes.arrayOf(PropTypes.string),
      suburb: PropTypes.string,
      state: PropTypes.string,
      postcode: PropTypes.string,
      country: PropTypes.string,
    }),
  }).isRequired,
  tripAdvisorRating: PropTypes.object.isRequired,
};

export default PropertyHeader;
